import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 43 41"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "currentColor",
      "fill-rule": "nonzero"
    }, [
      _createElementVNode("path", {
        fill: "#F96753",
        d: "M27.524 0C18.964 0 12 6.963 12 15.523 12 24.057 18.964 31 27.524 31 36.058 31 43 24.057 43 15.523 43 6.963 36.058 0 27.524 0"
      }),
      _createElementVNode("path", {
        fill: "#052A49",
        d: "M0 41V0h8v41z"
      })
    ], -1)
  ])))
}
export default { render: render }